import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const EyeBlockIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 -2 24 24"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.666 19.286a.737.737 0 0 0 1.038 0L21.33 1.747a.728.728 0 0 0 0-1.033.737.737 0 0 0-1.038 0L2.665 18.253a.728.728 0 0 0 0 1.033ZM16.4 2.432a.73.73 0 0 1 .379.961.736.736 0 0 1-.967.378c-1.265-.55-2.556-.835-3.813-.835-2.408 0-4.929 1.053-7.11 2.933-1.703 1.47-2.926 3.285-2.922 4.125.004.748 1.552 2.953 2.905 4.118l.052.043a.728.728 0 0 1 .1 1.028.737.737 0 0 1-1.034.1l-.062-.051C2.264 13.798.507 11.293.5 10.002c-.007-1.38 1.431-3.514 3.429-5.237 2.433-2.098 5.286-3.29 8.072-3.29 1.465 0 2.954.328 4.4.957Zm-8.824 15.12a.73.73 0 0 1-.377-.962.736.736 0 0 1 .968-.375c1.274.557 2.57.846 3.833.846 2.407 0 4.928-1.054 7.108-2.934 1.7-1.466 2.923-3.283 2.923-4.129 0-.846-1.223-2.663-2.912-4.12l-.03-.024-.038-.034a.728.728 0 0 1-.065-1.03.737.737 0 0 1 1.036-.065l.01.009.038.031C22.063 6.483 23.5 8.618 23.5 9.998c0 1.38-1.437 3.516-3.429 5.233-2.433 2.098-5.287 3.291-8.07 3.291-1.474 0-2.97-.333-4.424-.97Zm6.106-11.139a.73.73 0 0 0-.522-.892 4.675 4.675 0 0 0-1.188-.153c-2.566 0-4.653 2.076-4.653 4.63 0 .412.054.819.16 1.21a.735.735 0 0 0 1.418-.38 3.175 3.175 0 0 1-.11-.83 3.18 3.18 0 0 1 3.998-3.064.735.735 0 0 0 .897-.52Zm-2.85 8.074a.73.73 0 1 1 .36-1.417 3.18 3.18 0 0 0 3.963-3.072c0-.27-.034-.536-.1-.792a.734.734 0 0 1 1.422-.364c.097.375.147.763.147 1.156 0 2.554-2.086 4.63-4.653 4.63-.385 0-.768-.048-1.138-.14Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default EyeBlockIcon;
